export const FirebaseAppUrl =
  'https://homebot.page.link/?apn=com.homebot.app.android&isi=6448762620&ibi=com.homebot.app.ios&link=https://homebotapp.com/?_imcp=1&home_id=$homeId&share_code=$shareCode'
